import script from "./nfc.vue?vue&type=script&lang=ts&setup=true"
export * from "./nfc.vue?vue&type=script&lang=ts&setup=true"

import "./nfc.vue?vue&type=style&index=0&id=011be913&lang=scss"

const __exports__ = script;

export default __exports__